import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/simp_in/step3';
import { TypeFNSSimpleDescMarche } from '../models/TypeFNSSimpleDescMarche';
import { SimpINControlNames } from '../simpINControleNames';
@Component({
	selector: 'app-typeFNS-simple-desc-marche',
	templateUrl: './typeFNS-simple-desc-marche.component.html'
})
export class TypeFNSSimpleDescMarcheComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeFNSSimpleDescMarche';
	@Input() parentForm: FormGroup;

	@Input() disabled: boolean;
	@Input() natureMarche: TypeFNSSimpleDescMarche;

	public step3 = new Step3();

	constructor() {}

	public ngOnInit() {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

	getUidTranches() {
		return this.getUid() + '_SepSep_' + 'tranches';
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}
}
